/**
 * Tooltip mdule
 */
define([
    './directives/TooltipDirective',
    'imports?require=>function(arg){return window[arg];}!bower_components/tooltipster/dist/js/tooltipster.bundle'
], (TooltipDirective)=> {
    angular.module('edge.platform.widgets.tooltip', [])
        .directive('gwTooltip', TooltipDirective);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/tooltip/module.js